import React, { useState, useEffect } from "react";

export const FooterSection = () => {
  return (
    <footer className="py-8 border-t border-[#FF4D00]/10">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-gray-400">© 2025 Helga Festival App. All rights reserved.</p>
        <nav>
          <ul className="flex gap-6">
            <li>
              <a
                href="/"
                className="text-gray-400 hover:text-[#FF4D00] transition"
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="/privacy"
                className="text-gray-400 hover:text-[#FF4D00] transition"
              >
                Privacy
              </a>
            </li>
            <li>
              <a
                href="/terms"
                className="text-gray-400 hover:text-[#FF4D00] transition"
              >
                Impressum
              </a>
            </li>

          </ul>
        </nav>
      </div>
    </footer>
  );
};
